<template>
    <div>
        <toggle-button-with-middle
            :is-disabled="!isHasQuestions || disabled"
            v-model="isAllQuestionsAnswersIsRandomOrder"
            :is-middle="!allQuestionsHasSameRandomAnswerOrder && isHasQuestions"
            :callback="updateTestAllQuestionAnswersRandomOrder"
        />
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ToggleButtonWithMiddle from "../../../../utils/forms/ToggleButtonWithMiddle";
export default {
    name: "ToggleAllAnswerRandomOrder",
    components: {ToggleButtonWithMiddle},
    props: {
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        ...mapGetters('tests', [
            'testBeingEdited',
            'trans',
            'requestsProgress',
            'isAllQuestionsAnswersIsRandomOrder',
        ]),
        allQuestionsHasSameRandomAnswerOrder() {
            if (!this.isHasQuestions) {
                return false;
            }

            const questionsWithRandomOrder = this.questions.filter(item => item.settings.is_random_order);

            return questionsWithRandomOrder.length === 0 || questionsWithRandomOrder.length === this.questions.length;
        },
        isHasQuestions() {
            return this.questions.length > 0;
        },
        questions() {
            return Object.values(this.testBeingEdited.questions);
        }
    },
    methods: {
        ...mapActions('tests', [
            'updateTestAllQuestionAnswersRandomOrder',
        ]),
    }
}
</script>